import { ChangeDetectionStrategy, Component, inject, input, output, viewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SeFeMenuComponent, SeFeMenuOptions } from 'se-fe-menu';

@Component({
  selector: 'app-status-filter-menu',
  standalone: false,
  templateUrl: './status-filter-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusFilterMenuComponent {
  readonly disabled = input(false);
  readonly filterApplied = output<string[]>();
  readonly filterCleared = output<void>();
  readonly selectedStatuses = input<readonly string[]>([]);

  readonly menu = viewChild.required('statusMenu', { read: SeFeMenuComponent });

  private readonly formBuilder = inject(FormBuilder);
  private readonly translateService = inject(TranslateService);

  readonly discountStatusFilter = 'discount-status-filter';
  readonly statusMenuOptions: SeFeMenuOptions = {
    name: this.discountStatusFilter,
    title: this.translateService.instant('DISCOUNTS.LIST_VIEW.FILTERS.status'),
    cardLabel: this.translateService.instant('DISCOUNTS.LIST_VIEW.FILTERS.status_filter'),
    minWidth: '300px',
    actions: [
      {
        label: this.translateService.instant('DISCOUNTS.LIST_VIEW.FILTERS.apply'),
        action: () => this.applyFilter(),
      },
      {
        label: this.translateService.instant('DISCOUNTS.LIST_VIEW.FILTERS.clear'),
        action: () => this.clearFilter(),
      },
    ],
  };
  readonly statusOptions: StatusFilterOption[] = [
    { label: this.translateService.instant('DISCOUNTS.LIST_VIEW.FILTERS.active'), value: 'active' },
    { label: this.translateService.instant('DISCOUNTS.LIST_VIEW.FILTERS.redeemed'), value: 'redeemed' },
    { label: this.translateService.instant('DISCOUNTS.LIST_VIEW.FILTERS.expired'), value: 'expired' },
    { label: this.translateService.instant('DISCOUNTS.LIST_VIEW.FILTERS.scheduled'), value: 'scheduled' },
  ];
  readonly form = this.formBuilder.nonNullable.group({
    statuses: this.formBuilder.nonNullable.control<string[]>([]),
  });

  onMenuOpened(): void {
    this.form.controls.statuses.setValue([...this.selectedStatuses()]);
  }

  applyFilter(): void {
    this.menu().closeMenu();
    this.filterApplied.emit([...this.form.controls.statuses.getRawValue()]);
  }

  clearFilter(): void {
    this.form.controls.statuses.setValue([]);
    this.menu().closeMenu();
    this.filterCleared.emit();
  }
}

interface StatusFilterOption {
  label: string;
  value: string;
}
